// extracted by mini-css-extract-plugin
module.exports = {"highlight":"highlight_highlight__FOsEK","count":"highlight_count__pMtyo","label":"highlight_label__utCLH"};